import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CreateTemplateDrawerComponent } from './template-drawer/create-template/create-template-drawer.component'
import { UploadTemplateComponent } from './template-drawer/components/upload-template/upload-template.component'
import { AddRolesFormComponent } from './template-drawer/components/add-roles-form/add-roles-form.component'
import { PlaceFieldsFormComponent } from './template-drawer/components/place-fields-form/place-fields-form.component'
import { TemplateDetailsFormComponent } from './template-drawer/components/template-details-form/template-details-form.component'
import { TemplateUploaderComponent } from './template-drawer/components/template-uploader/template-uploader.component'
import { TemplateFieldsEditorComponent } from './template-drawer/components/fields-editor/template-fields-editor.component'
import { TemplateFieldsSelectorComponent } from './template-drawer/components/fields-selector/template-fields-selector.component'
import { SignaturePlaceholderComponent } from './template-drawer/components/fields/signature-placeholder/signature-placeholder.component'
import { InitialsPlaceholderComponent } from './template-drawer/components/fields/initials-placeholder/initials-placeholder.component'
import { CheckboxPlaceholderComponent } from './template-drawer/components/fields/checkbox-placeholder/checkbox-placeholder.component'
import { SigndatePlaceholderComponent } from './template-drawer/components/fields/signdate-placeholder/signdate-placeholder.component'
import { TextboxPlaceholderComponent } from './template-drawer/components/fields/textbox-placeholder/textbox-placeholder.component'
import { DataDicPlaceholderComponent } from './template-drawer/components/fields/data-dic-placeholder/data-dic-placeholder.component'
import { MiniCustomCodesComponent } from './template-drawer/components/custom-codes/mini-custom-codes.component'
import { EditTemplateDrawerComponent } from './template-drawer/edit-template/edit-template-drawer.component'
import { FieldSettingFormComponent } from './template-drawer/components/fields/field-setting-form/field-setting-form.component'
import { FieldRendererComponent } from './template-drawer/components/fields/field-renderer/field-renderer.component'
import { FieldPlaceholderComponent } from './template-drawer/components/fields/field-placeholder.component'
import { SendContractInfoFormComponent } from './template-drawer/components/send-contract-info-form/send-contract-info-form.component'
import { SendDocumentDrawerComponent } from '@tv3/containers/documents/templates/send-drawer/send-document/send-document-drawer.component'
import { SignerCustomInputComponent } from '@tv3/containers/documents/templates/send-drawer/components/signer-input/signer-custom-input.component'
import { SignersWithoutRoleComponent } from '@tv3/containers/documents/templates/send-drawer/components/signers-without-role/signers-without-role.component'
import { SendTemplateDrawerComponent } from '@tv3/containers/documents/templates/send-drawer/send-template/send-template-drawer.component'
import { SignersWithRoleComponent } from '@tv3/containers/documents/templates/send-drawer/components/signers-with-role/signers-with-role.component'
import { SignerSelectInputComponent } from '@tv3/containers/documents/templates/send-drawer/components/signer-select/signer-select-input.component'
import { DocumentSentAlertComponent } from '@tv3/containers/documents/templates/send-drawer/components/document-sent-alert/document-sent-alert.component'
import { SignerItemFormComponent } from '@tv3/containers/documents/templates/send-drawer/components/signer-item-form/signer-item-form.component'
import { PreviewTemplateDrawerComponent } from './template-drawer/preview-template/preview-template-drawer.component'
import { RoleItemFormComponent } from './template-drawer/components/role-item-form/role-item-form.component'
import { SigningOrderEditorComponent } from './template-drawer/components/signing-order-editor/signing-order-editor.component'
import { SignerFormDirective } from './template-drawer/components/signing-order-editor/signing-order-editor.directive'
import { SigningDiagramComponent } from './template-drawer/components/signing-diagram/signing-diagram.component'
import { PrefillFieldPlaceholderComponent } from './template-drawer/components/fields/prefill-field-placeholder/prefill-field-placeholder.component'
import { TemplateMessageDialogComponent } from '@tv3/containers/documents/templates/dialogs/message/template-message-dialog.component'
import { RenameTemplateDialogComponent } from '@tv3/containers/documents/templates/dialogs/rename/rename-template-dialog.component'
import { FormRoleInputComponent } from '@tv3/containers/documents/templates/template-drawer/components/form-role-input/form-role-input.component'
import { DocumentSharedModule } from '@tv3/containers/documents/shared/document-shared.module'
import { DocumentTemplatesComponent } from '@tv3/containers/documents/templates/list/document-templates.component'
import { CustomCodesSharedModule } from '@tv3/containers/rentals/custom-codes/custom-codes-shared.module'

const signFieldComponents = [
  FieldSettingFormComponent,
  FieldRendererComponent,
  FieldPlaceholderComponent,
  SignaturePlaceholderComponent,
  InitialsPlaceholderComponent,
  SigndatePlaceholderComponent,
  CheckboxPlaceholderComponent,
  TextboxPlaceholderComponent,
  DataDicPlaceholderComponent,
  PrefillFieldPlaceholderComponent,
]

const components = [
  ...signFieldComponents,
  MiniCustomCodesComponent,
  TemplateFieldsSelectorComponent,

  TemplateUploaderComponent,
  UploadTemplateComponent,
  FormRoleInputComponent,
  RoleItemFormComponent,
  AddRolesFormComponent,
  PlaceFieldsFormComponent,
  TemplateDetailsFormComponent,

  TemplateFieldsEditorComponent,
  CreateTemplateDrawerComponent,
  EditTemplateDrawerComponent,
  TemplateMessageDialogComponent,
  RenameTemplateDialogComponent,

  SignerFormDirective,
  SigningOrderEditorComponent,
  SigningDiagramComponent,

  SendContractInfoFormComponent,
  SignerCustomInputComponent,
  SignerSelectInputComponent,
  SignerItemFormComponent,
  SignersWithoutRoleComponent,
  SignersWithRoleComponent,
  SendDocumentDrawerComponent,
  SendTemplateDrawerComponent,
  DocumentSentAlertComponent,

  PreviewTemplateDrawerComponent,

  //
  DocumentTemplatesComponent,
]

const services = [
  //
]

const modules = [
  //
  DocumentSharedModule,
  CustomCodesSharedModule,
]

@NgModule({
  declarations: [...components],
  imports: [CommonModule, ...modules],
  exports: [...components, ...modules],
  providers: [...services],
})
export class TemplatesSharedModule {}
